import type { Adventure } from '../../types'

// Tower Builder - Age 4-5 - Advanced shape stacking with balance
export const tillyTowerCorrect = [
  "Perfect tower! Amazing balance!",
  "That's right! Great engineering!",
  "Excellent! You understand balance!",
  "Wonderful! What a tall tower!",
  "Yes! Perfect stacking order!",
  "Brilliant! You are an architect!",
  "Super job! Stable and tall!",
  "You got it! Tower master!",
  "Fantastic structure! Well done!",
  "Amazing tower! Future engineer!"
]

export const tillyTowerWrong = [
  "Hmm, will that stack stay up? Try biggest first!",
  "Almost! Big base makes a stable tower!",
  "Good try! Stack big to small for balance!",
  "So close! Think about tower strength!",
  "Big shapes on bottom, small on top!",
  "You are learning! Build a strong base!",
  "Try again! Wide base, tall top!",
  "Think about balance! Big first!",
  "Let's build together! Big shapes down!",
  "Keep trying! You will build it high!"
]

export const towerBuilderAdventure: Adventure = {
  id: 'tower-builder',
  title: 'Tower Builder',
  theme: 'shapes',
  targetAge: '4',
  difficulty: 'medium',
  estimatedDuration: 9,
  segments: {
    intro: {
      id: 'intro',
      tillyLine: "Hello builder! I am Tilly! Let us construct amazing towers! Big shapes on bottom, small on top!",
      duration: 4
    },
    story1: {
      id: 'story-1',
      tillyLine: "To build a tall tower that will not fall, start with a BIG wide base! Then add smaller shapes on top!",
      duration: 5
    },
    choice1: [
      {
        id: 'castle',
        label: 'Build a castle!',
        tillyLine: "Royal castle!",
        nextState: 'quiz-1'
      },
      {
        id: 'rocket',
        label: 'Build a rocket!',
        tillyLine: "To the moon!",
        nextState: 'story-2'
      }
    ],
    quiz1: {
      id: 'quiz-1',
      type: 'tap-correct',
      question: 'Build a castle tower! Which goes FIRST (bottom)?',
      tillyPrompt: 'Biggest base first!',
      options: [
        { id: 'wide', label: '⬜ Wide Base', isCorrect: true },
        { id: 'medium', label: '⬜ Medium', isCorrect: false },
        { id: 'small', label: '⬜ Small Top', isCorrect: false }
      ]
    } as any,
    story2: {
      id: 'story-2',
      tillyLine: "Wonderful! Now let us build a space rocket! Pointy top, wide bottom - ready for launch!",
      duration: 4
    },
    choice2: [
      {
        id: 'launch',
        label: 'Launch rocket!',
        tillyLine: "3, 2, 1, blast off!",
        nextState: 'quiz-2'
      },
      {
        id: 'skyscraper',
        label: 'Build skyscraper!',
        tillyLine: "Reach the clouds!",
        nextState: 'quiz-2'
      }
    ],
    quiz2: {
      id: 'quiz-2',
      type: 'tap-correct',
      question: 'Stack the rocket: Wide base, medium body, pointy top!',
      tillyPrompt: 'Which goes FIRST?',
      options: [
        { id: 'wide', label: '⬛ Wide Base', isCorrect: true },
        { id: 'medium', label: '⬛ Body', isCorrect: false },
        { id: 'pointy', label: '🔺 Pointy Top', isCorrect: false }
      ]
    } as any,
    challenge: {
      intro: {
        id: 'challenge-intro',
        tillyLine: "Master builder! Challenge Round: Complex structures with many shapes!",
        duration: 4
      },
      quizzes: [
        {
          id: 'challenge-1',
          type: 'tap-correct',
          question: 'Build a pyramid: 4 levels big to small!',
          tillyPrompt: 'Which is the BASE?',
          options: [
            { id: 'xl', label: '⬜ XL', isCorrect: true },
            { id: 'large', label: '⬜ Large', isCorrect: false },
            { id: 'medium', label: '⬜ Medium', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-2',
          type: 'tap-correct',
          question: 'Build a house: Roof on top, door in middle!',
          tillyPrompt: 'Start with the base!',
          options: [
            { id: 'base', label: '🟫 House Base', isCorrect: true },
            { id: 'door', label: '🚪 Door', isCorrect: false },
            { id: 'roof', label: '🔺 Roof', isCorrect: false }
          ]
        } as any,
        {
          id: 'challenge-3',
          type: 'tap-correct',
          question: 'Expert: Bridge with arch! Base, pillar, arch!',
          tillyPrompt: 'What supports it all?',
          options: [
            { id: 'base', label: '⬛ Bridge Base', isCorrect: true },
            { id: 'pillar', label: '⬛ Pillar', isCorrect: false },
            { id: 'arch', label: '⛩️ Arch', isCorrect: false }
          ]
        } as any
      ]
    },
    reward: {
      tillyLine: "Outstanding! You are a Master Tower Builder! Engineering excellence achieved!",
      badgeName: 'Master Builder',
      badgeIcon: '👷',
      nextPreview: 'Next time, we will do more addition adventures!'
    }
  }
}
